<template>
  <div id="modalLogin" class="modal fade in" role="dialog" data-backdrop="true" data-keyboard="false"
    style="padding-right: 5px;">
    <div class="modal-dialog">

      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-header-inner">
            <span class="modal-title">ลงชื่อเข้าใช้</span>
            <div class="modal-close" data-dismiss="modal">
              <i class="fa fa-times" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <form class="login-form" novalidate="novalidate">
            <div class="form-group form-special">
              <div class="input-holder">
                <input id="login_username" v-model="phoneNumber" name="login_username" type="text"
                  placeholder="ยูสเซอร์เนม">
              </div>
              <div class="jErr"></div>
            </div>
            <div class="form-group form-special">
              <div class="input-holder">
                <input v-model="password" id="login_password" name="login_password"
                  :type="showpass == false ? 'password' : 'text'" placeholder="รหัสผ่าน">
                <span class="input-icon" @click="showpass = !showpass">
                  <i class="fa fa-eye-slash vPassView" v-if="showpass == false"></i>
                  <i class="fa fa-eye vPassView" v-if="showpass == true"></i>
                </span>
              </div>
              <div class="jErr"></div>
            </div>
          </form>
          <div class="pull-right">


            <label class="control control-checkbox">
              <input v-model="remember" :value="true" type="checkbox">
              <div class="control_indicator"></div>
              <span>จำฉัน</span>
            </label>
          </div>
          <div class="clearfix"></div>
          <div class="text-center">
            <div id="btnLogin" @click="Login()" class="button button-big button-signup button-round mgt15">ลงชื่อเข้าใช้
            </div>
            <div class="text-white fs12 mgt15 mgb15">ยังไม่เป็นสมาชิก?<a id="btnJoinnow" class="button-link-blue pdl5"
                href="javascript:void(0);" @click="gotoRoute('/register')">เข้าร่วมตอนนี้</a></div>
            <div id="btnGoForgotPassword" v-bind:href="`https://line.me/R/ti/p/${getLineId}`" target="_blank"
              class="btn button-link">ลืมรหัสผ่าน?</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div id="modalLogin" tabindex="-1" aria-labelledby="modalLabel-login" data-modal="modal" class=" modal x-modal -v2"
    style="" aria-hidden="true">
    <div class=" modal-dialog modal-dialog-centered ">
      <div class="contentmodal animate__animated animate__bounceInDown modal-content -modal-content">
        <div class="modal-body -modal-body">
          <button type="button" class="close f-1 -in-tab" data-bs-dismiss="modal" aria-label="Close">
            <i class="fas fa-times"></i>
          </button>
          <div class="x-modal-account-security-tabs -v2">
            <button type="button" class="-btn -register js-modal-account-security-tab-button " data-bs-toggle="modal"
              data-bs-target="#modalRegister">
              สมัครสมาชิก
            </button>
            <button type="button" class="-btn -login js-modal-account-security-tab-button -active" data-bs-toggle="modal"
              data-bs-target="#modalLogin">
              เข้าสู่ระบบ
            </button>
          </div> 
          <div class="x-modal-separator-container x-login-form">
            <input v-model="phoneNumber" class=" mb-4 mt-3 form-control x-form-control" id="txtUserName" type="text"
              placeholder="ชื่อผู้ใช้" />
            <input v-model="password" class="form-control x-form-control" id="password" name="password" type="password"
              placeholder="รหัสผ่าน" />

            <div class="mb-3 form-check">
              <input v-model="remember" :value="true" type="checkbox" id="f-condition" class="form-check-input" />
              <label for="f-condition" class="form-check-label">
                จดจำฉันไว้ในระบบ
              </label>
              <div class="d-block w-100 p-1"></div>
            </div>

            <button @click="Login()" class="btn btn-primary -submit" id="btnLogin">
              เข้าสู่ระบบ
            </button>

            <div class="modalspanbox">
              ยังไม่เป็นสมาชิก?
              <a class="registerbtn" data-bs-toggle="modal" data-bs-target="#modalRegister">สมัครสมาชิก</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "LoginForm",
  data() {
    return {
      phoneNumber: "",
      password: "",
      showpass: false,
      remember: false,
    };
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
    ]),
  },
  methods: {
    ...mapActions(["userSignIn", "setError"]),
    async Login() {
      if (
        this.phoneNumber == "" ||
        this.password == "" ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          "เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง",
          "",
          "error"
        );
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      });
      if (this.getError) {
        return this.$swal.fire(this.getError, "", "error");
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem("remember.username", this.phoneNumber);
          localStorage.setItem("remember.password", this.password);
        } else {
          localStorage.removeItem("remember.username");
          localStorage.removeItem("remember.password");
        }
        localStorage.removeItem("modal-alert");
      }
    },
  },
  mounted() {
    this.setError(null);
    if (localStorage.getItem("remember.username") != null) {
      this.phoneNumber = localStorage.getItem("remember.username");
      this.remember = true;
    }
    if (localStorage.getItem("remember.password") != null) {
      this.password = localStorage.getItem("remember.password");
      this.remember = true;
    }
  },
};
</script>

<style scoped>
.form-check-input[type="checkbox"] {
  width: 1em;
  border-radius: 0.25em;
}
</style>



// WEBPACK FOOTER //
// src/components/form/LoginForm.vue